var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat-on-Batch-Upload",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Batch-Chat-View-Copy-2",
    transform: "translate(-514.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(514.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#FFDB00",
    cx: 8.5,
    cy: 8.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81548927,8.602423 C5.93893784,8.5941945 5.23076923,7.84259156 5.23076923,6.91663022 C5.23076923,5.98555491 5.94678171,5.23076923 6.83002785,5.23076923 C7.21760975,5.23076923 7.57298932,5.37610988 7.849796,5.61790957 C8.57865814,6.20154052 8.64660045,7.16005804 8.57848998,7.73853103 C8.45899603,9.23384409 7.45858786,10.1415132 5.57726546,10.4615385 C5.57726546,10.0476926 5.57726546,9.84076973 5.57726546,9.84076973 C6.25117976,9.66270332 6.66392103,9.24992107 6.81548927,8.602423 Z M11.2934134,8.602423 C10.416862,8.5941945 9.70869338,7.84259156 9.70869338,6.91663022 C9.70869338,5.98555491 10.4247059,5.23076923 11.307952,5.23076923 C11.6955339,5.23076923 12.0509135,5.37610988 12.3277201,5.61790957 C13.0565823,6.20154052 13.1245246,7.16005804 13.0564141,7.73853103 C12.9369202,9.23384409 11.936512,10.1415132 10.0551896,10.4615385 C10.0551896,10.0476926 10.0551896,9.84076973 10.0551896,9.84076973 C10.7291039,9.66270332 11.1418452,9.24992107 11.2934134,8.602423 Z",
    id: "Combined-Shape",
    fill: "#444444"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuote);
export default __webpack_public_path__ + "static/media/icon-quote.1117f8aaa14e1af241541cda1fb7c6d9.svg";
export { ForwardRef as ReactComponent };